export default __webpack_public_path__ + "static/j-victoria-college-front-name-board-fafbe02836e127cb1b230ab5a4a18981.jpg";